import { render, staticRenderFns } from "./ContabilitaDocumentiViewPage.vue?vue&type=template&id=6a3278cb"
import script from "./ContabilitaDocumentiViewPage.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentiViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports